import { ArrayStepper } from "./fields/ArrayStepper";
import { AutocompleteComponent } from "./fields/Autocomplete";
import CheckboxComponent from "./fields/Checkbox";
import DatePickerComponent from "./fields/DatePicker";
import DateTimePickerComponent from "./fields/DateTimePicker";
import DividerComponent from "./fields/Divider";
import LabelComponent from "./fields/Label";
import RadioComponent from "./fields/Radio";
import RepeaterTextAreaFieldComponent from "./fields/RepeaterTextAreaField";
import SectionHeaderComponent from "./fields/SectionHeader";
import SectionTitleComponent from "./fields/SectionTitle";
import SelectComponent from "./fields/Select";
import SwitchComponent from "./fields/Switch";
import TextFieldComponent from "./fields/TextField";
import TextareaFieldComponent from "./fields/TextAreaField";

export type * from "./types";

export const defaultComponents = {
  text: TextFieldComponent,
  textarea: TextareaFieldComponent,
  select: SelectComponent,
  checkbox: CheckboxComponent,
  switch: SwitchComponent,
  radio: RadioComponent,
  date: DatePickerComponent,
  datetime: DateTimePickerComponent,
  autocomplete: AutocompleteComponent,
  sectionHeader: SectionHeaderComponent,
  label: LabelComponent,
  divider: DividerComponent,
  sectionTitle: SectionTitleComponent,
  repeaterTextAreaField: RepeaterTextAreaFieldComponent,
  arrayStepper: ArrayStepper,
};

// Export individual components for direct use
export {
  ArrayStepper,
  CheckboxComponent,
  DatePickerComponent,
  DateTimePickerComponent,
  DividerComponent,
  LabelComponent,
  RadioComponent,
  RepeaterTextAreaFieldComponent,
  SectionHeaderComponent,
  SectionTitleComponent,
  SelectComponent,
  SwitchComponent,
  TextFieldComponent,
};
